import { render } from "./LeslaboratoiresPage.vue?vue&type=template&id=e7fd7cc4"
import script from "./LeslaboratoiresPage.vue?vue&type=script&lang=js"
export * from "./LeslaboratoiresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__